const messages: Record<string, string> = {
	'feedback.headline': 'Dziękujemy za skorzystanie z aplikacji!',
	'feedback.description': ' ',
	'feedback.rating': 'Jak oceniasz proces wprowadzania danych do naszej aplikacji?',

	'fourDiagonalPerspectives.vehicleFrontLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleRearRight.title': ' ',
	'fourAdditionalPictures.overallDashboard.title': ' ',
	'fourAdditionalPictures.overallDashboard.description':
		'Deska rozdzielcza (zdjęcie powinno obejmować całą deskę rozdzielczą)',
	'fourAdditionalPictures.mileage.title': ' ',
	'dashboardMileage.dashboard.paragraph':
		'Stan licznika (zdjęcie powinno odzwierciedlać stan licznika podany przy zawieraniu polisy)',
	'fourAdditionalPictures.vin.title': ' ',
	'fourAdditionalPictures.vin.description':
		'Numer VIN (widoczny i pełny umieszczony na stałym elemencie pojazdu – NIE są akceptowane zdjęcia tabliczek znamionowych)',

	'approval.headline': 'Propozycja rozliczenia szkody',
	'approval.paragraph':
		'Propozycja rozliczenia szkody została skalkulowana w oparciu o realne cenniki części zamiennych stosowanych do napraw pojazdów oraz stawki robocizny stosowane w serwisach naprawczych. W przypadku zainteresowania naprawą pojazdu w serwisie współpracującej z Unext sieci Inter Cars prosimy o kontakt z Opiekunem szkody lub Infolinią Unext, tel. Nr 22 123 55 55.<br>Jeżeli zaakceptujesz propozycję, niezwłocznie po ustaleniu odpowiedzialności przekażemy pieniądze na Twoje konto. Nie będziesz musiał dokumentować naprawy rachunkami. Zawsze jednak będziesz mógł rozliczyć się z nami przedkładając kosztorys z wybranego serwisu i rachunki za wykonaną naprawę.',

	'waitForAudit.description.damageFound':
		'Dziękujemy za przesłanie dokumentacji. Nasz ekspert zweryfikuje dokumentację w ciągu maksymalnie 1 dnia roboczego, o wynikach poinformujemy odrębnym sms-em i/lub emailem.',
	'waitForAudit.description.damageNotFound':
		'Dziękujemy za przesłanie dokumentacji. Nasz ekspert zweryfikuje dokumentację w ciągu maksymalnie 1 dnia roboczego, o wynikach poinformujemy odrębnym sms-em i/lub emailem.',

	'button.start': 'Dalej',

	'invalidFile.size.title': 'Nieprawidłowy rozmiar zdjęcia',
	'invalidFile.size.description': 'Zdjęcie jest większe niż maksymalny dozwolony rozmiar.',
	'invalidFile.extension.title': 'Nieobsługiwany typ pliku',
	'invalidFile.extension.description':
		'Podany typ pliku nie jest obsługiwany. Obsługiwane typy plików: .jpg, .jpeg, .jfif, .heic, .heif, .png oraz .bmp',
};

export default messages;
